<template>
  <div class="m-pickup-filters">
    <pickup-filters-actions
      :value="value"
      @input="onChangeFilters"
      @click="isSidebarOpened = true"
    />

    <transition name="fade">
      <vue-client-only>
        <div
          v-if="!adaptive.isDesktop && isSidebarOpened"
          class="m-pickup-filters__overlay"
          @click.self="isSidebarOpened = !isSidebarOpened"
        >
          <pickup-filters-sidebar
            :value="value"
            @close="isSidebarOpened = false"
            @input="onChangeFilters"
          />
        </div>
      </vue-client-only>
    </transition>
  </div>
</template>

<script>
import VueClientOnly from 'vue-client-only';
import PickupFiltersSidebar from '@/components/checkout/delivery-selector/pickup-filters/pickup-filters-sidebar.vue';
import PickupFiltersActions from '@/components/checkout/delivery-selector/pickup-filters/pickup-filters-actions.vue';

export default {
  name: 'm-pickup-filters',

  components: {
    PickupFiltersActions,
    PickupFiltersSidebar,
    VueClientOnly,
  },

  inject: ['adaptive'],

  props: {
    value: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    isSidebarOpened: false,
  }),

  methods: {
    onChangeFilters(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss">
.m-pickup-filters {
  display: flex;
  flex-direction: column;
  padding: 12px;
  background-color: $gray_bgr;
  border-radius: 4px;

  &__overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 3;
    background-color: rgba(51, 51, 51, .64);
  }
}

@include breakpoint("tablet") {
  .m-pickup-filters {
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }
}

@include breakpoint("desktop") {
  .m-pickup-filters {
    padding: 10px 12px;
    margin-top: 9px;
  }
}
</style>
